module.exports = __webpack_public_path__ + "img/Nash-white.8411408a.png";